/**
 * PHP-injected origin for app REST calls (passkeys, getauthid).
 *
 * When PHP embeds a React dist it sets `window._msApiEndpointApp`:
 *   - app PHP: `location.origin` (we already are the app host)
 *   - www PHP: `getPlatformHost('app')` (localhost-app / dev.app / app)
 *
 * Without this, passkey helpers keep the Vite-baked `VITE_MS_API_ENDPOINT_APP`
 * (Dev/prod) and a local page talks to DEV across origins.
 *
 * Hosted Amplify / `pnpm dev` never set `_msApiEndpointApp`; callers keep the
 * configured Vite app URL.
 */
export function resolvePhpApiEndpointApp(configuredBase: string): string {
  return globalThis.window?._msApiEndpointApp || configuredBase;
}
